import React from 'react'
import ProtectedRoute from '../../internal/ProtectedRoute'
import { Authorities } from '../../models/authorities'

import Humany from './Humany'
import Documents from './Documents'
import Order from './Order'

const SupportRoutes = () => (
  <div>
    <ProtectedRoute
      key="/support/faq"
      path="/support/faq"
      authority={Authorities.SUPPORT}
      page={<Humany />}
    />
    <ProtectedRoute
      key="/support/docs"
      path="/support/docs"
      authority={Authorities.SUPPORT}
      page={<Documents />}
    />
    <ProtectedRoute
      key="/support/order"
      path="/support/order"
      authority={Authorities.SUPPORT}
      page={<Order />}
    />
  </div>
)

export default SupportRoutes
